import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import ListErrors from './widgets/ListErrors'
import { Link } from 'react-router-dom'
import {
} from '../constants/actionTypes'
const mapStateToProps = state => ({
  ...state.auth,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
})

class Home extends React.Component {
  constructor() {
    super()
  }
  componentWillMount() {
  }

  componentWillUnmount() {
    //this.props.onUnload();
  }
  render() {

    let applicationVersion

    try { applicationVersion = process.env.npm_package_version || require('../../package.json').version } catch (err) { applicationVersion = 'N/A' }

    return (
      <div></div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
